import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import Loader from './Loader'

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';
import Hidden from '@material-ui/core/Hidden';

import InstaTable from './InstaTable'
import ReceiptIcon from '../../assets/receipt.svg'
import ResendIcon from '../../assets/resend.svg'

import {
  payments_index,
  payment_receipt,
  payments_xlsx,
  send_receipt,
  preferences_index,
  templates_select,
  coupons_select,
  set_path,
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals } = state.payment
  return {
    payment: state.payment,
    payments: items,
    pagination: pagination,
    totals: totals,
    current_user: state.auth.current_user.data,
    skills: state.skill.items,
    templates: state.template.select_items,
    coupons: state.coupon.select_items,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getPayments: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( payments_index(page, per_page, filters, sort, order) ),
    paymentsXLSX: (filters={}, sort='', order='') => dispatch( payments_xlsx(filters, sort, order) ),
    setPath: path => dispatch( set_path(path) ),
    getCoupons: () => dispatch( coupons_select() ),
    getPreferences: () => dispatch( preferences_index() ),
    getTemplates: () => dispatch( templates_select() ),
    getReceipt: payment_id => dispatch( payment_receipt(payment_id) ),
    sendReceipt: payment_id => dispatch( send_receipt(payment_id) ),
  }
}

class ConnectedPaymentsIndex extends React.Component {
  state={
    current_payment: {},
    current_view: 'all',
    init_filters: {},
    merge_filters: {},
    current_id: undefined,
    filterState: {},
    showPreview: false,
    mounted: false
  }

  fieldGetter(field, item, instate) {
    let renderText
    // const state = {
    //   ...instate,
    //   filters: {
    //     ...instate.filters,
    //     ...this.state.merge_filters
    //   }
    // }
    if (field === "created_at") {
      renderText = new Date(item[field]).toLocaleDateString()
    } else if (field === "status") {
      renderText = this.statusIcon(item[field])
    } else if (field === 'id') {
      renderText = item[field]
    } else if (field === 'test_id') {
      renderText = (
        <Link to={`/tests/test?test=${item.test_id}`} className="test_results_link" title="Test Results" target="_blank" onClick={e => {
          e.stopPropagation()
        }}>
          {item.test_id}
        </Link>
      )
    } else if (field === 'template') {
      renderText = item.template ? item.template.name : ''
    } else if (field === 'role') {
      const roles = {
        expert: "Skill Expert",
        admin: "Global Administrator",
        creator: "Data Content Creator",
        user: "Test Taker"
      }
      renderText = item.user ? roles[item.user.role] : ''
    } else if (field === 'user') {
      renderText = item.user ? (
        <Link to={`/users/${item.user.id}/edit`} className="test_results_link" title="Edit User" target="_blank" onClick={e => {
          e.stopPropagation()
        }}>
          <div className="td-user-email">{item.user.email}</div>
          <div className="td-user-name">{item.user.name}</div>
        </Link>
      ) : ''
    } else if (field === 'skill') {
      renderText = item.skill ? item.skill.name : ''
    } else if (field === 'transaction_id') {
      renderText = item.transaction ? item.transaction.id : ''
    } else if (field === 'coupon') {
      renderText = item.coupon ? item.coupon.name : ''
    } else if (field === 'discount' || field === 'amount_total' || field === 'amount_final' ) {
      renderText = `${item[field].toFixed(2)} €`
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          { item.status === "success" && this.getReceipt(item) }
          { item.status === "success" && this.sendReceipt(item) }
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getPayments, getPreferences, getTemplates, getCoupons, setPath, coupons, templates, skills } = this.props
    setPath('payments')
    if ( !templates || templates.length === 0 ) {
      getTemplates()
    }
    if ( !coupons || coupons.length === 0 ) {
      getCoupons()
    }
    if ( !skills || skills.length === 0 ) {
      getPreferences()
    }
    const {location} = this.props
    // const {init_filters} = this.state
    let filters = {}
    if ( location && location.state && location.state.user ) {
      filters = {
        ...filters,
        search: location.state.user
      }
      this.setState({ init_filters: filters })
    }
    getPayments(1, 10, filters)

  }

  componentWillUnmount() {
    // this.props.resetTemplate()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (prevProps.payment.fetching && !this.props.payment.fetching && this.props.payment.fetched) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else {
      this.setState({merge_filters: {status: value}})
    }
    this.setState({current_view: value})
  }

  getReceipt = item => {
    const {id} = item
    return (
      <Link to ={`/payments/${id}/receipt`} className="action-btn" title="Download receipt" onClick={ e=> {
        e.preventDefault()
        this.props.getReceipt(id)
      }}>
        <img src={ReceiptIcon} height={16} alt="Download Action"/>
      </Link>
    )
  }

  sendReceipt = item => {
    const {id} = item
    return (
      <Link to ={`/payments/${id}/send_receipt`} className="action-btn" title="Resend receipt" onClick={ e=> {
        e.preventDefault()
        this.props.sendReceipt(id)
      }}>
        <img src={ResendIcon} height={16} alt="Resend Action"/>
      </Link>
    )
  }


  hideDialog() {
    this.setState({showPreview: false, current_payment: {}})
  }

  statusIcon = status => {
    let icon = null
    if (status === 'success') {
      icon = 'check_circle'
    } else if (status === 'draft') {
      icon = 'insert_drive_file'
    } else if (status === 'expired') {
      icon = 'timer_off'
    } else if (status === 'consumed') {
      icon = "done_all"
    } else if (status === 'revoked') {
      icon = "delete"
    }
    if (icon !== null) {
      return <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title={capitalize(status)}>{icon}</Icon>
    }
  }

  showPreview = (item, field, state) => {
    const { filters, sort, order } = state
    this.setState({showPreview: true, current_payment: item, previewFilters: filters, previewSort: sort, previewOrder: order})
  }

  headerButton = (filters, sort, order) => {
    return (
      <Hidden smDown>
        <a href='' style={{float: 'right'}} onClick={e => {
          e.preventDefault()
          this.props.paymentsXLSX(filters, sort, order)
        }}>
          Download XLSX
        </a>
      </Hidden>
    )
  }


  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( role !== 'admin' ) {
      return <Redirect to="/" />
    }

    const { payments, pagination, totals, coupons } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'transaction_id', disablePadding: true, label: 'Trans. ID', disableSort: true },
      { id: 'test_id', disablePadding: true, label: 'Test ID', disableSort: true },
      // { id: 'role', disablePadding: true, label: 'User Type' },
      { id: 'user', disablePadding: true, label: 'User' },
      { id: 'created_at', disablePadding: true, label: 'Date' },
      { id: 'amount_total', disablePadding: true, label: 'Total Due' },
      { id: 'coupon', disablePadding: true, label: 'Coupon' },
      { id: 'discount', disablePadding: true, label: 'Discount' },
      { id: 'amount_final', disablePadding: true, label: 'Total Paid' },
      // { id: 'status', disablePadding: true, label: 'Status', disableSort: true },
      // { id: 'template', disablePadding: true, label: 'Template' },
      // { id: 'skill', disablePadding: true, label: 'Skill' },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true },
    ]

    const filterControls = [
      // { name: "skill", filter_type: "select", valueField: "name", collection: skills  },
      // { name: "template", filter_type: "select", valueField: "name", collection: templates },
      { name: "coupon", filter_type: "select", valueField: "name", collection: coupons },
      { name: "search", filter_type: "search" },
      { name: "created_at", filter_type: "date" },
    ]

    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "coupon", label: "Coupon", value: totals.coupon },
      { name: "card", label: "Fully Paid", value: totals.card },
    ]

    return (
      <div id="payments-wrapper" className={this.props.payment.fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            Purchases
          </Typography>
        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={payments}
          pagination={pagination}
          role={role}
          search={true}
          placeholders="User, Transaction, Test"
          merge_filters={this.state.merge_filters}
          init_filters={this.state.init_filters}
          rowGetter={this.props.getPayments.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          classPrefix="payments"
          addClassField="status"
          headerButton={this.headerButton.bind(this)}
        />
        {
          // previewColumn="id"
          // previewItem={this.showPreview.bind(this)}
          // <PaymentPreview
          //   id="preview-payment-dialog"
          //   isopen={this.state.showPreview}
          //   filters={{...this.state.previewFilters, ...this.state.merge_filters}}
          //   sort={this.state.previewSort}
          //   order={this.state.previewOrder}
          //   payment_id={this.state.current_payment.id}
          //   handleClose={this.hideDialog.bind(this)}
          // />
        }
        {
          // <CustomDialog
          //   id="delete-dialog"
          //   fullScreen = {false}
          //   qid={this.state.current_id}
          //   isopen={this.state.showDialog}
          //   handleClose={this.hideDialog.bind(this)}
          //   handleAccept={this.destroy.bind(this)}
          //   title="Delete Payment?"
          // >
          //   This action cannot be undone
          // </CustomDialog>
        }

      </div>
    )
  }
}

const PaymentsIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedPaymentsIndex)

export default withStyles(styles)(PaymentsIndex)



// WEBPACK FOOTER //
// ./src/js/components/PaymentsIndex.js